import React from 'react';
import { Bot, BookOpen, Users, GraduationCap, Shield, BarChart3, TrendingUp, Activity, CheckCircle2 } from 'lucide-react';
import PhoneFrame from '../phone-frame/PhoneFrame';

const features = [
  {
    id: 1,
    icon: Bot,
    title: 'AI Analysis Real-time',
    description: 'Analisis pasar saham & crypto berbasis AI yang memberikan insight akurat berbasis data. Dapatkan rekomendasi, deteksi tren, dan sentimen pasar secara instan.',
    points: [
      'Analisis sentimen pasar real-time',
      'Deteksi tren & pola teknikal otomatis',
      'Rekomendasi buy/sell berbasis AI',
      'Notifikasi pergerakan harga penting',
    ],
    gradient: 'linear-gradient(145deg, #0a1628, #0f2940)',
    accentBorder: 'rgba(12,143,134,0.25)',
  },
  {
    id: 2,
    icon: BookOpen,
    title: 'Akademi Trading Lengkap',
    description: 'Belajar dari nol hingga mahir dengan kurikulum terstruktur. Video tutorial berkualitas, modul interaktif, dan studi kasus nyata dari mentor berpengalaman.',
    points: [
      'Modul dari pemula hingga expert',
      'Video HD & studi kasus real',
      'Sertifikat resmi kelulusan',
      'Akses materi seumur hidup',
    ],
    gradient: 'linear-gradient(145deg, #0a1628, #0f2a3a)',
    accentBorder: 'rgba(46,114,210,0.25)',
  },
  {
    id: 3,
    icon: Users,
    title: 'Komunitas Trader Aktif',
    description: 'Bergabung dengan ribuan trader Indonesia. Diskusi strategi, sharing pengalaman, dan networking dalam ekosistem yang suportif dan kolaboratif.',
    points: [
      'Grup diskusi berdasarkan topik',
      'Sharing strategi & analisis pasar',
      'Tanya jawab langsung dengan mentor',
      'Networking sesama trader',
    ],
    gradient: 'linear-gradient(145deg, #0a1628, #1a2a3a)',
    accentBorder: 'rgba(88,189,125,0.25)',
  },
  {
    id: 4,
    icon: GraduationCap,
    title: 'Mentor Profesional',
    description: 'Belajar langsung dari mentor bersertifikasi dengan pengalaman industri. Sesi 1-on-1, evaluasi portofolio, dan konsultasi strategi investasi.',
    points: [
      'Sesi mentoring personal 1-on-1',
      'Evaluasi & optimasi portofolio',
      'Konsultasi strategi investasi',
      'Rencana belajar yang dipersonalisasi',
    ],
    gradient: 'linear-gradient(145deg, #0a1628, #1c1540)',
    accentBorder: 'rgba(139,92,246,0.25)',
  },
  {
    id: 5,
    icon: Shield,
    title: 'Paper Trading Aman',
    description: 'Latihan trading menggunakan dana virtual tanpa risiko. Data pasar real-time, cocok untuk mengasah skill sebelum terjun ke pasar sesungguhnya.',
    points: [
      'Dana virtual hingga Rp 100 juta',
      'Data & harga pasar real-time',
      'Zero risk, nol modal sungguhan',
      'Laporan & evaluasi performa',
    ],
    gradient: 'linear-gradient(145deg, #0a1628, #0f2a20)',
    accentBorder: 'rgba(88,189,125,0.25)',
  },
  {
    id: 6,
    icon: BarChart3,
    title: 'Investment Journal',
    description: 'Catat dan evaluasi setiap keputusan investasi Anda. Lacak performa portofolio, dapatkan laporan analitik, dan optimalkan strategi trading.',
    points: [
      'Pencatatan transaksi otomatis',
      'Tracking performa portofolio',
      'Laporan analitik bulanan',
      'Grafik performa interaktif',
    ],
    gradient: 'linear-gradient(145deg, #0a1628, #0f1a2e)',
    accentBorder: 'rgba(12,143,134,0.25)',
  },
];

const phoneScreens = [
  // Screen 1 - AI Analysis
  <>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
      <span style={{ color: '#0C8F86', fontSize: 11, fontWeight: 700 }}>AI ANALYSIS</span>
      <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: 9 }}>Real-time</span>
    </div>
    <div style={{ background: 'rgba(12,143,134,0.12)', borderRadius: 10, padding: 12, marginBottom: 8, border: '1px solid rgba(12,143,134,0.18)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 }}>
        <Bot size={13} color="#0C8F86" />
        <span style={{ color: '#0C8F86', fontSize: 10, fontWeight: 700 }}>REKOMENDASI AI</span>
      </div>
      <div style={{ color: '#fff', fontSize: 11, lineHeight: 1.5 }}>
        BBCA potensi <span style={{ color: '#58bd7d' }}>bullish</span>. Volume naik 2.3x & RSI menunjukkan momentum positif.
      </div>
    </div>
    <div style={{ background: 'rgba(255,255,255,0.04)', borderRadius: 10, padding: 12, marginBottom: 8 }}>
      <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 9, marginBottom: 8, fontWeight: 600 }}>SENTIMEN PASAR HARI INI</div>
      <div style={{ display: 'flex', gap: 6 }}>
        {[
          { label: 'Bullish', pct: 62, color: '#58bd7d' },
          { label: 'Sideways', pct: 24, color: '#f59e0b' },
          { label: 'Bearish', pct: 14, color: '#ef4444' },
        ].map((s, i) => (
          <div key={i} style={{ flex: 1, background: `${s.color}10`, borderRadius: 8, padding: '10px 4px', textAlign: 'center', border: `1px solid ${s.color}20` }}>
            <div style={{ color: s.color, fontSize: 14, fontWeight: 800 }}>{s.pct}%</div>
            <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 8, marginTop: 2 }}>{s.label}</div>
          </div>
        ))}
      </div>
    </div>
    <div style={{ background: 'rgba(255,255,255,0.04)', borderRadius: 10, padding: 10 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
        <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: 9 }}>IHSG</span>
        <span style={{ color: '#58bd7d', fontSize: 9, fontWeight: 700 }}>+1.24%</span>
      </div>
      <div style={{ height: 40, background: 'rgba(12,143,134,0.06)', borderRadius: 6, display: 'flex', alignItems: 'flex-end', padding: '2px 0', gap: 2, justifyContent: 'space-around' }}>
        {[30, 55, 40, 70, 50, 80, 60, 95, 65, 85, 72, 90, 60, 78, 88].map((h, i) => (
          <div key={i} style={{ width: 6, height: `${h}%`, background: h > 70 ? '#58bd7d' : 'rgba(12,143,134,0.4)', borderRadius: '2px 2px 0 0' }} />
        ))}
      </div>
    </div>
  </>,

  // Screen 2 - Akademi
  <>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
      <span style={{ color: '#2e72d2', fontSize: 11, fontWeight: 700 }}>AKADEMI</span>
      <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: 9 }}>12 Kursus</span>
    </div>
    <div style={{ background: 'rgba(255,255,255,0.06)', borderRadius: 8, padding: '10px 12px', marginBottom: 10, color: 'rgba(255,255,255,0.35)', fontSize: 11, display: 'flex', alignItems: 'center', gap: 6 }}>
      <Activity size={12} /> Cari kursus...
    </div>
    {[
      { title: 'Fundamental Saham', level: 'Pemula', progress: 82, color: '#0C8F86' },
      { title: 'Teknikal Analisis', level: 'Menengah', progress: 48, color: '#2e72d2' },
      { title: 'Crypto Trading', level: 'Mahir', progress: 15, color: '#8b5cf6' },
    ].map((c, i) => (
      <div key={i} style={{ background: 'rgba(255,255,255,0.04)', borderRadius: 10, padding: '10px 12px', marginBottom: 8, border: `1px solid ${c.color}15` }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
          <span style={{ color: '#fff', fontSize: 10, fontWeight: 600 }}>{c.title}</span>
          <span style={{ color: c.color, fontSize: 8, background: `${c.color}15`, padding: '2px 8px', borderRadius: 4, fontWeight: 600 }}>{c.level}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <div style={{ flex: 1, height: 4, background: 'rgba(255,255,255,0.08)', borderRadius: 2, overflow: 'hidden' }}>
            <div style={{ width: `${c.progress}%`, height: '100%', background: c.color, borderRadius: 2 }} />
          </div>
          <span style={{ color: 'rgba(255,255,255,0.35)', fontSize: 8 }}>{c.progress}%</span>
        </div>
      </div>
    ))}
  </>,

  // Screen 3 - Komunitas
  <>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
      <span style={{ color: '#58bd7d', fontSize: 11, fontWeight: 700 }}>KOMUNITAS</span>
      <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: 9 }}>2.3K online</span>
    </div>
    <div style={{ display: 'flex', gap: 4, marginBottom: 10, justifyContent: 'center' }}>
      {[1,2,3,4,5,6].map(i => (
        <div key={i} style={{ width: 26, height: 26, borderRadius: '50%', border: '2px solid rgba(88,189,125,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(88,189,125,0.1)' }}>
          <Users size={12} color="#58bd7d" />
        </div>
      ))}
    </div>
    {[
      { user: 'Dimas_Trader', text: 'Hasil analisis IHSG: potensi rebound di support 7.150. Konfirmasi candle bullish di TF daily. Thoughts? 📊', likes: 24, replies: 7 },
      { user: 'Rina_Analyst', text: 'Webinar teknikal tadi malam bahas divergence pattern sangat insightful! Ada yang punya link rekamannya? 🙏', likes: 18, replies: 5 },
    ].map((p, i) => (
      <div key={i} style={{ background: 'rgba(255,255,255,0.04)', borderRadius: 10, padding: '10px 12px', marginBottom: 8, border: '1px solid rgba(255,255,255,0.05)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: 6 }}>
          <div style={{ width: 20, height: 20, borderRadius: '50%', background: 'linear-gradient(135deg, #0C8F86, #58bd7d)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 8, fontWeight: 700 }}>{p.user[0]}</div>
          <span style={{ color: '#fff', fontSize: 9, fontWeight: 600 }}>{p.user}</span>
          <span style={{ color: 'rgba(255,255,255,0.3)', fontSize: 8, marginLeft: 'auto' }}>• 5m ago</span>
        </div>
        <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 9, lineHeight: 1.5, marginBottom: 6 }}>{p.text}</p>
        <div style={{ display: 'flex', gap: 12 }}>
          <span style={{ color: 'rgba(255,255,255,0.3)', fontSize: 8, display: 'flex', alignItems: 'center', gap: 3 }}>
            <TrendingUp size={9} /> {p.likes}
          </span>
          <span style={{ color: 'rgba(255,255,255,0.3)', fontSize: 8, display: 'flex', alignItems: 'center', gap: 3 }}>
            <Activity size={9} /> {p.replies}
          </span>
        </div>
      </div>
    ))}
  </>,

  // Screen 4 - Mentor
  <>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
      <span style={{ color: '#8b5cf6', fontSize: 11, fontWeight: 700 }}>MENTOR</span>
      <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: 9 }}>8 Tersedia</span>
    </div>
    {[
      { name: 'Dimas Prasetyo', role: 'Senior Trader', exp: '12 tahun', sessions: 24, color: '#0C8F86' },
      { name: 'Rina Wijaya', role: 'Analis Teknikal', exp: '8 tahun', sessions: 18, color: '#8b5cf6' },
      { name: 'Andre Susanto', role: 'Crypto Specialist', exp: '6 tahun', sessions: 15, color: '#f59e0b' },
    ].map((m, i) => (
      <div key={i} style={{ background: 'rgba(255,255,255,0.04)', borderRadius: 10, padding: '10px 12px', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 10, border: `1px solid ${m.color}15` }}>
        <div style={{ width: 34, height: 34, borderRadius: '50%', background: `linear-gradient(135deg, ${m.color}, ${m.color}dd)`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 13, fontWeight: 700 }}>{m.name[0]}</div>
        <div style={{ flex: 1 }}>
          <div style={{ color: '#fff', fontSize: 10, fontWeight: 600, marginBottom: 1 }}>{m.name}</div>
          <div style={{ color: 'rgba(255,255,255,0.45)', fontSize: 8 }}>{m.role} · {m.exp}</div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ color: m.color, fontSize: 10, fontWeight: 700 }}>{m.sessions}</div>
          <div style={{ color: 'rgba(255,255,255,0.35)', fontSize: 8 }}>sesi</div>
        </div>
      </div>
    ))}
    <div style={{ background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)', borderRadius: 8, padding: '10px 0', textAlign: 'center', color: '#fff', fontSize: 10, fontWeight: 600, cursor: 'pointer' }}>
      + Lihat Semua Mentor
    </div>
  </>,

  // Screen 5 - Paper Trading
  <>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
      <span style={{ color: '#58bd7d', fontSize: 11, fontWeight: 700 }}>PAPER TRADING</span>
      <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: 9 }}>Simulasi</span>
    </div>
    <div style={{ background: 'rgba(88,189,125,0.12)', borderRadius: 12, padding: 14, marginBottom: 12, border: '1px solid rgba(88,189,125,0.18)' }}>
      <div style={{ color: 'rgba(255,255,255,0.45)', fontSize: 9, marginBottom: 4, fontWeight: 600 }}>SALDO VIRTUAL</div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
        <span style={{ color: '#58bd7d', fontSize: 22, fontWeight: 800 }}>Rp 98,5M</span>
        <div style={{ background: 'rgba(88,189,125,0.17)', borderRadius: 6, padding: '4px 8px', color: '#58bd7d', fontSize: 10, fontWeight: 700 }}>+2.4%</div>
      </div>
    </div>
    <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 9, marginBottom: 10, fontWeight: 600 }}>PORTFOLIO</div>
    {[
      { name: 'BBCA', qty: '50 lot', pl: '+Rp 340.000', pct: '+1.7%', up: true },
      { name: 'BBRI', qty: '100 lot', pl: '-Rp 120.000', pct: '-0.8%', up: false },
      { name: 'ASII', qty: '75 lot', pl: '+Rp 215.000', pct: '+2.1%', up: true },
    ].map((s, i) => (
      <div key={i} style={{ background: 'rgba(255,255,255,0.04)', borderRadius: 8, padding: '8px 10px', marginBottom: 6, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <div style={{ color: '#fff', fontSize: 10, fontWeight: 600 }}>{s.name}</div>
          <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 8 }}>{s.qty}</div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ color: s.up ? '#58bd7d' : '#ef4444', fontSize: 10, fontWeight: 700 }}>{s.pl}</div>
          <div style={{ color: s.up ? '#58bd7d' : '#ef4444', fontSize: 8, opacity: 0.7 }}>{s.pct}</div>
        </div>
      </div>
    ))}
  </>,

  // Screen 6 - Journal
  <>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
      <span style={{ color: '#0C8F86', fontSize: 11, fontWeight: 700 }}>JOURNAL</span>
      <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: 9 }}>Agustus 2026</span>
    </div>
    <div style={{ background: 'rgba(255,255,255,0.05)', borderRadius: 12, padding: 14, marginBottom: 12 }}>
      <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 9, marginBottom: 8, fontWeight: 600 }}>PERFORMA BULAN INI</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 6 }}>
        {[
          { label: 'Total Aset', val: 'Rp 52,3M', color: '#fff' },
          { label: 'Return', val: '+8.4%', color: '#58bd7d' },
          { label: 'Win Rate', val: '67%', color: '#0C8F86' },
        ].map((s, i) => (
          <div key={i} style={{ textAlign: 'center', background: 'rgba(255,255,255,0.03)', borderRadius: 8, padding: '10px 4px' }}>
            <div style={{ color: s.color, fontSize: 14, fontWeight: 800, marginBottom: 2 }}>{s.val}</div>
            <div style={{ color: 'rgba(255,255,255,0.35)', fontSize: 8 }}>{s.label}</div>
          </div>
        ))}
      </div>
    </div>
    <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 9, marginBottom: 10, fontWeight: 600 }}>
      <Activity size={10} style={{ display: 'inline', marginRight: 4 }} /> TRANSAKSI TERAKHIR
    </div>
    {[
      { action: 'Beli', name: 'BBCA', qty: '100', price: 'Rp 9.850', color: '#58bd7d' },
      { action: 'Jual', name: 'TLKM', qty: '200', price: 'Rp 4.120', color: '#ef4444' },
      { action: 'Beli', name: 'ASII', qty: '50', price: 'Rp 6.750', color: '#58bd7d' },
    ].map((t, i) => (
      <div key={i} style={{ background: 'rgba(255,255,255,0.04)', borderRadius: 8, padding: '8px 10px', marginBottom: 6, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ background: `${t.color}18`, color: t.color, fontSize: 8, fontWeight: 700, padding: '3px 7px', borderRadius: 4 }}>{t.action}</span>
          <div>
            <div style={{ color: '#fff', fontSize: 10, fontWeight: 600 }}>{t.name}</div>
            <div style={{ color: 'rgba(255,255,255,0.35)', fontSize: 8 }}>{t.qty} lot · {t.price}</div>
          </div>
        </div>
      </div>
    ))}
  </>,
];

function AppFeatures() {
  return (
    <section className="app-features" style={{ padding: '100px 0', background: 'var(--surface)' }}>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="block-text center" style={{ marginBottom: 64 }}>
              <h3 className="heading">Fitur Unggulan Tradiora</h3>
              <p className="fs-20" style={{ color: 'var(--text)', maxWidth: 580, margin: '12px auto 0' }}>
                Platform all-in-one yang dirancang untuk membantu Anda sukses di pasar saham dan crypto.
              </p>
            </div>
          </div>
        </div>

        {features.map((feature, index) => {
          const Icon = feature.icon;
          const isOdd = index % 2 === 1;

          return (
            <div
              key={feature.id}
              className="row align-items-center"
              style={{ marginBottom: index < features.length - 1 ? 100 : 0 }}
              data-aos="fade-up"
              data-aos-duration="800"
            >
              <div className={`col-xl-6 col-lg-6 col-md-12 ${isOdd ? 'order-xl-2' : ''}`}>
                <div style={{ padding: '0 20px' }}>
                  <div style={{
                    width: 56, height: 56, borderRadius: 16,
                    background: 'linear-gradient(135deg, var(--primary), #087a72)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    marginBottom: 20, boxShadow: '0 10px 35px rgba(12,143,134,0.25)',
                  }}>
                    <Icon size={28} color="#fff" />
                  </div>
                  <h3 style={{ fontSize: 28, fontWeight: 700, color: 'var(--onsurface)', marginBottom: 12 }}>
                    {feature.title}
                  </h3>
                  <p style={{ fontSize: 16, color: 'var(--text)', lineHeight: 1.75, marginBottom: 22 }}>
                    {feature.description}
                  </p>
                  <ul style={{ padding: 0 }}>
                    {feature.points.map((point, i) => (
                      <li key={i} style={{
                        display: 'flex', alignItems: 'center', gap: 10,
                        marginBottom: 12, fontSize: 14, color: 'var(--onsurface)',
                      }}>
                        <span style={{
                          width: 22, height: 22, borderRadius: '50%',
                          background: 'rgba(12,143,134,0.1)', color: 'var(--primary)',
                          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                          fontSize: 10, flexShrink: 0,
                        }}>
                          <CheckCircle2 size={12} />
                        </span>
                        {point}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className={`col-xl-6 col-lg-6 col-md-12 ${isOdd ? 'order-xl-1' : ''}`}>
                <div style={{ display: 'flex', justifyContent: 'center', padding: '30px 0' }}>
                  <PhoneFrame style={{ width: 270, height: 540, maxWidth: '78vw' }}>
                    <div style={{
                      height: '100%',
                      background: feature.gradient,
                      borderRadius: '0 0 30px 30px',
                      padding: '14px 14px',
                      display: 'flex',
                      flexDirection: 'column',
                      border: `1px solid ${feature.accentBorder}`,
                    }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', color: 'rgba(255,255,255,0.5)', fontSize: 10, marginBottom: 12, padding: '0 2px' }}>
                        <span>9:41</span>
                        <span style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                          <span style={{ width: 4, height: 4, borderRadius: '50%', background: 'rgba(255,255,255,0.4)', display: 'inline-block' }} />
                          <span style={{ width: 4, height: 4, borderRadius: '50%', background: 'rgba(255,255,255,0.4)', display: 'inline-block' }} />
                          <span style={{ width: 4, height: 4, borderRadius: '50%', background: 'rgba(255,255,255,0.4)', display: 'inline-block' }} />
                        </span>
                      </div>
                      {phoneScreens[index]}
                    </div>
                  </PhoneFrame>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default AppFeatures;
